import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NeoComunService } from '../../../comun/services/neoComun.service';
import { NeoIntermediarioFinancieroService } from '../../Service/neoIntermediarioFinanciero.service';
import { NeoTipoNegacion } from '../../../comun/models/neoTipoNegacion';
import { NeoTiposNegacionService } from '../../../comun/services/neoTiposNegacion.service';
import { AlertService } from '../../../services/alert.service';
import { RouterService } from '../../../services/router.service';
import { UserService } from '../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { TrazabilidadAuditoriaService } from '../../Service/trazabilidad-auditoria.service';
import { NeoTrazabilidadAuditoriaDTO } from '../../Model/neoTrazabilidadAuditoriaDTO';
import { Constantes } from 'src/app/comun/data/constantes';
declare var $: any;

const datosDetalleSolicitud = {
  idSolicitud: '',
  usuario: null,
};

const datosNegarSolicitudAprobador = {
  idCliente: null,
  idSolicitud: '',
  id_tipo_negacion: null,
  idUsuario: null,
};
@Component({
    selector: 'app-negar-oferta-if',
    templateUrl: './negar-oferta-if.component.html',
    styleUrls: ['./negar-oferta-if.component.scss'],
    providers: [
        NeoComunService,
        NeoIntermediarioFinancieroService,
        NeoTiposNegacionService,
    ],
    standalone: false
})
export class NegarOfertaIfComponent implements OnInit {
  public detalleSolcitud: any;
  public user;
  tipoNegacionId: Number = 0;
  public tiposNegacion: NeoTipoNegacion[] = [];
  idTrazabilidad: number = 0;

  isTransaccional: boolean = false;

  constructor(
    public router: Router,
    private _route: ActivatedRoute,
    private _neoComunService: NeoComunService,
    private _userIntermediarioService: UserService,
    private _neoIntermediarioFinancieroService: NeoIntermediarioFinancieroService,
    private _neoTiposNegacionService: NeoTiposNegacionService,
    private alertService: AlertService,
    private _router: RouterService,
    private _sweetAlert: SweetAlertService,
    private readonly _serviceTrazabilidad: TrazabilidadAuditoriaService
  ) {
    this.user = this._userIntermediarioService.getUser();
    const nav = this.router.getCurrentNavigation();
    this.isTransaccional = nav?.extras.state?.['from'] === Constantes.TRANSACCIONAL;
  }

  ngOnInit(): void {

    this._route.params.subscribe((params: Params) => {
      datosDetalleSolicitud.idSolicitud = params['id'];
      datosDetalleSolicitud.usuario = Number(this.user.idUsuario);
    });

    /* this._neoComunService.getDetalleSolicitud(datosDetalleSolicitud).subscribe(
      (response) => {
        this.detalleSolcitud = response;
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,
          'No fue posible cargar el detalle de la solicitud'
        );
        this.router.navigate(['intermediario/transaccional/aprobarSolicitudes']);
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      }
    ); */

    this._neoTiposNegacionService.getTiposNegacionHabilitados().subscribe(
      (response) => {
        this.tiposNegacion = response;
        this.rechazoOferta();
      },
      (error) => {
        this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar los tipos de negación');
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      }
    );

    datosNegarSolicitudAprobador.idCliente = Number(this.user.idCliente);
    datosNegarSolicitudAprobador.idSolicitud =
      datosDetalleSolicitud.idSolicitud;
    datosNegarSolicitudAprobador.idUsuario = Number(this.user.idUsuario);
  }

  cancelar() {
    this.cerrarTrazabilidad(this.idTrazabilidad);
    this._router.goBack();
  }

  negar() {
    if (this.tipoNegacionId != 0) {
      datosNegarSolicitudAprobador.id_tipo_negacion = Number(
        this.tipoNegacionId
      );
      this._neoIntermediarioFinancieroService
        .negarSolicitudAprobador(datosNegarSolicitudAprobador)
        .subscribe(
          (response) => {
            if (response['exitoso'] == true) {
              this.cerrarTrazabilidad(this.idTrazabilidad);
              this._sweetAlert.successModal('¡Éxito!',
                false,
                'La oferta ha sido negada correctamente').then(
                  (result) => {
                    if (result.isConfirmed) {
                      this.router.navigate(['/intermediario/home']);
                    }
                  });
              // $('#aceptarModal').modal('show');
            } else {
              this._sweetAlert.errorModal("Error!", true, 'No fue posible negar la oferta');
            }
          },
          (error) => {
            this._sweetAlert.errorModal("Error!", true, 'No fue posible negar la oferta');
          }
        );
    } else {
      this._sweetAlert.errorModal("Error!", true, 'Seleccione el tipo de negación');
    }
  }

  aceptar() {
    $('#aceptarModal').modal('hide');
    this.router.navigate(['/intermediario/home']);
  }

  // Trazabilidad
  rechazoOferta() {
    const body: NeoTrazabilidadAuditoriaDTO = {
      nombreSeccion: this.isTransaccional ? Constantes.TRANSACCIONAL : Constantes.HOME,
      nombrePantalla: Constantes.NEGAR_OFERTA,
      idCliente: +this.user.idCliente,
      idUsuario: +this.user.idUsuario,
      idSolicitud: String(datosNegarSolicitudAprobador.idSolicitud),
      perfil: Constantes.PERFIL_ALIADO
    }
    this._serviceTrazabilidad.generarRechazoOferta(body).subscribe(
      {
        next: resp => {
          this.idTrazabilidad = resp.trazabilidad.idTrazabilidad;
        },
        error: err => {
        }
      });

  }


  cerrarTrazabilidad(idTrazabilidad: number) {
    this._serviceTrazabilidad.cierreTrazabilidad(idTrazabilidad).subscribe({
      next: resp => {
      },
      error: err => {
      }
    });
  }
}
